const postTypeOptions = [
  {
    text: "Facebook Post",
    value: 1,
    icon: "facebook",
    suffix: "facebook-post",
    color: "#4267B2",
  },
  {
    text: "Facebook Story",
    value: 2,
    icon: "facebook",
    suffix: "story",
    color: "#4267B2",
  },
  {
    text: "Instagram Post",
    value: 3,
    icon: "instagram",
    suffix: "instagram-post",
    color: "#5B51D8",
  },
  {
    text: "Instagram Story",
    value: 4,
    icon: "instagram",
    suffix: "story",
    color: "#5B51D8",
  },
  {
    text: "Tweet",
    value: 5,
    icon: "twitter",
    suffix: "facebook-post",
    color: "#1DA1F2",
  },
];

export default postTypeOptions;
